/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';
import {
    Field_BudgetField_Fragment,
    Field_ClientConfiguredField_Fragment,
    Field_ContestUpgradesChoiceField_Fragment,
    Field_DateField_Fragment,
    Field_FilesField_Fragment,
    Field_GridChoiceField_Fragment,
    Field_InputField_Fragment,
    Field_LogoContestTierChoiceField_Fragment,
    Field_MultiChoiceField_Fragment,
    Field_MultiGridChoiceField_Fragment,
    Field_MultiInputField_Fragment,
    Field_MultiSelectChoiceField_Fragment,
    Field_PrintServiceOptionsField_Fragment,
    Field_RadioChoiceField_Fragment,
    Field_SelectChoiceField_Fragment,
    Field_SquarespacePackageChoiceField_Fragment,
    Field_TextAreaField_Fragment,
    Field_WorkEntityField_Fragment,
} from '../../../../../../libs/brief/src/components/Field/Field.generated';
import { DesignerCard_UserFragment } from '../components/DesignerCard.generated';
import { PaymentSummaryFragment } from '../components/PaymentSummary.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UploaderFragment = {
    __typename: 'UploaderConfig';
    requestAccessKey: string;
    bucket: string;
    requestEndpoint: string;
    signatureEndpoint: string;
    keyPrefix: string;
    signatureVersion: number;
    region: string;
};

export type StructuredBriefFileFragment = {
    __typename: 'StructuredBriefFile';
    bucket: string;
    key: string;
    name: string;
    previewable: boolean;
    size: number;
};

export type CategoryFieldsFragment = {
    __typename: 'Category';
    key: string;
    title: string;
    priceRange: Array<number>;
};

export type CategoryFragment = {
    __typename: 'Category';
    children: Array<{ __typename: 'Category' } & CategoryFieldsFragment>;
} & CategoryFieldsFragment;

export type IndustryFragment = { __typename: 'Industry'; key: string; title: string };

export type BriefDesignerFragment = {
    __typename: 'User';
    id: string;
    displayName: string;
    isDesigner: boolean;
};

export type UserFragment = { __typename: 'User'; id: string; isAdmin: boolean };

export type ViewerFragment = {
    __typename: 'Viewer';
    isRepeatClient: boolean;
    user: Types.Maybe<{ __typename: 'User' } & UserFragment>;
};

export type ValidationErrorFragment = {
    __typename: 'StructuredBriefValidationError';
    field: string;
    reason: string;
};

export type ProductFixedPriceProjectFragment = {
    __typename: 'ProductFixedPriceProject';
    key: string;
    title: string;
    description: string;
    summary: string;
    disclaimer: Types.Maybe<string>;
    fulfilmentMpvId: Types.Maybe<string>;
    details: Array<{ __typename: 'ProductPackageDetails' } & PackageDetailsFragment>;
    additionalDetails: Array<{ __typename: 'ProductPackageDetails' } & PackageDetailsFragment>;
    image: Types.Maybe<{ __typename: 'ProductPackageImage' } & PackageImageFragment>;
    headerVideo: Types.Maybe<
        { __typename: 'ProductPackageHeaderVideo' } & PackageHeaderVideoFragment
    >;
    pricing: { __typename: 'FixedPrice' } & FixedPriceFragment;
    marketing: Types.Maybe<{ __typename: 'Marketing' } & MarketingFragment>;
    categoryExperience: Array<{
        __typename: 'CategoryExperience';
        count: number;
        title: string;
        category: string;
    }>;
};

export type ProductContestFragment = {
    __typename: 'ProductContest';
    key: string;
    title: string;
    description: string;
    summary: string;
    contestDetails: Array<string>;
    pricing: { __typename: 'FixedPrice' } & FixedPriceFragment;
    image: Types.Maybe<{ __typename: 'ProductPackageImage' } & PackageImageFragment>;
    marketing: Types.Maybe<{ __typename: 'Marketing' } & MarketingFragment>;
};

export type ProductQuotedProjectFragment = {
    __typename: 'ProductQuotedProject';
    key: string;
    title: string;
    description: string;
    summary: string;
    quotedProjectDetails: Array<string>;
    priceRange: {
        __typename: 'PriceRange';
        fromPrice: Types.Maybe<number>;
        toPrice: Types.Maybe<number>;
    };
    image: Types.Maybe<{ __typename: 'ProductPackageImage' } & PackageImageFragment>;
    marketing: Types.Maybe<{ __typename: 'Marketing' } & MarketingFragment>;
};

export type FixedPriceFragment = {
    __typename: 'FixedPrice';
    subtotal: number;
    gst: Types.Maybe<number>;
    earningsInUsd: number;
    amounts: Array<{ __typename: 'Money'; currency: string; amountInCents: number }>;
    amount: { __typename: 'Money'; currency: string; amountInCents: number };
};

export type MarketingFragment = { __typename: 'Marketing'; key: string; iconKey: string };

export type IProduct_ProductFixedPriceProject_Fragment = {
    __typename: 'ProductFixedPriceProject';
} & ProductFixedPriceProjectFragment;

export type IProduct_ProductContest_Fragment = {
    __typename: 'ProductContest';
} & ProductContestFragment;

export type IProduct_ProductQuotedProject_Fragment = {
    __typename: 'ProductQuotedProject';
} & ProductQuotedProjectFragment;

export type IProductFragment =
    | IProduct_ProductFixedPriceProject_Fragment
    | IProduct_ProductContest_Fragment
    | IProduct_ProductQuotedProject_Fragment;

export type PackageDetailsFragment = {
    __typename: 'ProductPackageDetails';
    title: string;
    description: string;
    ctaLink: Types.Maybe<string>;
};

export type PackageImageFragment = {
    __typename: 'ProductPackageImage';
    title: string;
    src: string;
    points: Array<string>;
    attribution: string;
    alt: string;
};

export type PackageHeaderVideoFragment = {
    __typename: 'ProductPackageHeaderVideo';
    title: string;
    src: string;
    attribution: string;
};

export type PartnerCouponFragment = {
    __typename: 'PartnerCoupon';
    couponId: string;
    campaignId: string;
    expiry: Types.Maybe<any>;
    notBefore: Types.Maybe<any>;
    state: Types.PartnerCouponValidityState;
    validPackages: Array<string>;
};

export type LaunchBriefMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type LaunchBriefMutation = {
    __typename: 'Mutation';
    launchStructuredBrief: {
        __typename: 'StructuredBrief';
        id: string;
        state: Types.BriefState;
        projectIds: Array<number>;
        partnerCoupon: Types.Maybe<{
            __typename: 'PartnerCoupon';
            state: Types.PartnerCouponValidityState;
        }>;
        job: Types.Maybe<{ __typename: 'JobEntity'; id: string }>;
    };
};

export type ClaimBriefMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type ClaimBriefMutation = {
    __typename: 'Mutation';
    claimStructuredBrief: {
        __typename: 'StructuredBrief';
        id: string;
        userId: number;
        contacts: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
    };
};

export type UpdateBriefMutationVariables = Types.Exact<{
    id: Types.Scalars['ID'];
    fields: Types.StructuredBriefFieldsInput;
}>;

export type UpdateBriefMutation = {
    __typename: 'Mutation';
    brief: {
        __typename: 'StructuredBrief';
        id: string;
        errors: Array<{ __typename: 'StructuredBriefValidationError' } & ValidationErrorFragment>;
        dynamicFields: Array<
            | ({ __typename: 'SelectChoiceField' } & Field_SelectChoiceField_Fragment)
            | ({ __typename: 'MultiSelectChoiceField' } & Field_MultiSelectChoiceField_Fragment)
            | ({ __typename: 'GridChoiceField' } & Field_GridChoiceField_Fragment)
            | ({ __typename: 'RadioChoiceField' } & Field_RadioChoiceField_Fragment)
            | ({ __typename: 'MultiChoiceField' } & Field_MultiChoiceField_Fragment)
            | ({ __typename: 'BudgetField' } & Field_BudgetField_Fragment)
            | ({ __typename: 'DateField' } & Field_DateField_Fragment)
            | ({ __typename: 'FilesField' } & Field_FilesField_Fragment)
            | ({ __typename: 'TextAreaField' } & Field_TextAreaField_Fragment)
            | ({
                  __typename: 'SquarespacePackageChoiceField';
              } & Field_SquarespacePackageChoiceField_Fragment)
            | ({
                  __typename: 'LogoContestTierChoiceField';
              } & Field_LogoContestTierChoiceField_Fragment)
            | ({
                  __typename: 'ContestUpgradesChoiceField';
              } & Field_ContestUpgradesChoiceField_Fragment)
            | ({ __typename: 'PrintServiceOptionsField' } & Field_PrintServiceOptionsField_Fragment)
            | ({ __typename: 'InputField' } & Field_InputField_Fragment)
            | ({ __typename: 'MultiInputField' } & Field_MultiInputField_Fragment)
            | ({ __typename: 'MultiGridChoiceField' } & Field_MultiGridChoiceField_Fragment)
            | ({ __typename: 'ClientConfiguredField' } & Field_ClientConfiguredField_Fragment)
            | ({ __typename: 'WorkEntityField' } & Field_WorkEntityField_Fragment)
        >;
        paymentSummary: Types.Maybe<{ __typename: 'PaymentSummary' } & PaymentSummaryFragment>;
    };
};

export type BriefQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type BriefQuery = {
    __typename: 'Query';
    brief: {
        __typename: 'StructuredBrief';
        id: string;
        source: string;
        state: Types.BriefState;
        userId: number;
        foreignKeys: Array<number>;
        isBundled: boolean;
        schemaId: string;
        category: Types.Maybe<{ __typename: 'Category'; key: string }>;
        designers: Array<{
            __typename: 'DesignerWithSource';
            id: number;
            source: Types.DesignerSource;
        }>;
    };
};

export type GetOrderPaymentRequestQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
    redirectPath: Types.Scalars['String'];
}>;

export type GetOrderPaymentRequestQuery = {
    __typename: 'Query';
    brief: { __typename: 'StructuredBrief'; id: string; orderPaymentRequest: Types.Maybe<any> };
};

export type GetBriefLaunchPermissionsQueryVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type GetBriefLaunchPermissionsQuery = {
    __typename: 'Query';
    brief: {
        __typename: 'StructuredBrief';
        id: string;
        launchPermissions: Types.Maybe<{
            __typename: 'LaunchPermissions';
            clientPermission: { __typename: 'LaunchPermission' } & LaunchPermissionFragment;
            designerPermissions: Array<
                { __typename: 'LaunchPermission' } & LaunchPermissionFragment
            >;
        }>;
    };
};

export type LaunchPermissionFragment = {
    __typename: 'LaunchPermission';
    canLaunch: boolean;
    reason: Types.Maybe<Types.LaunchPermissionReason>;
    user: { __typename: 'User'; displayName: string };
};

export type CommonBriefFieldsFragment = {
    __typename: 'StructuredBrief';
    id: string;
    userId: number;
    schemaId: string;
    state: Types.BriefState;
    projectIds: Array<number>;
    category: Types.Maybe<{ __typename: 'Category' } & CategoryFieldsFragment>;
    uploader: { __typename: 'UploaderConfig' } & UploaderFragment;
    contacts: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
    designers: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
    errors: Array<{ __typename: 'StructuredBriefValidationError' } & ValidationErrorFragment>;
    designersWithSource: Array<{ __typename: 'DesignerWithSource'; source: Types.DesignerSource }>;
    product: Types.Maybe<
        { __typename: 'ProductFixedPriceProject' } & ProductFixedPriceProjectFragment
    >;
};

export const StructuredBriefFileFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'StructuredBriefFile' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'StructuredBriefFile' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewable' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                ],
            },
        },
    ],
};
export const CategoryFieldsFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'priceRange' } },
                ],
            },
        },
    ],
};
export const CategoryFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Category' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CategoryFields' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CategoryFields' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'priceRange' } },
                ],
            },
        },
    ],
};
export const IndustryFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Industry' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Industry' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                ],
            },
        },
    ],
};
export const BriefDesignerFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BriefDesigner' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDesigner' } },
                ],
            },
        },
    ],
};
export const UserFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                ],
            },
        },
    ],
};
export const ViewerFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Viewer' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Viewer' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'User' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'isRepeatClient' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                ],
            },
        },
    ],
};
export const PackageDetailsFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageDetails' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageDetails' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ctaLink' } },
                ],
            },
        },
    ],
};
export const PackageImageFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
    ],
};
export const PackageHeaderVideoFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageHeaderVideo' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageHeaderVideo' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                ],
            },
        },
    ],
};
export const FixedPriceFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const MarketingFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
    ],
};
export const ProductFixedPriceProjectFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalDetails' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headerVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageHeaderVideo' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'fulfilmentMpvId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryExperience' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageDetails' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageDetails' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ctaLink' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageHeaderVideo' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageHeaderVideo' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                ],
            },
        },
    ],
};
export const ProductContestFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductContest' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductContest' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'contestDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
    ],
};
export const ProductQuotedProjectFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductQuotedProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductQuotedProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quotedProjectDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRange' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fromPrice' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'toPrice' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
    ],
};
export const IProductFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'IProduct' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IProduct' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ProductFixedPriceProject' },
                    },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductContest' } },
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ProductQuotedProject' },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalDetails' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headerVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageHeaderVideo' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'fulfilmentMpvId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryExperience' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductContest' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductContest' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'contestDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductQuotedProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductQuotedProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quotedProjectDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRange' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fromPrice' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'toPrice' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageDetails' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageDetails' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ctaLink' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageHeaderVideo' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageHeaderVideo' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                ],
            },
        },
    ],
};
export const PartnerCouponFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PartnerCoupon' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PartnerCoupon' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'couponId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'campaignId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expiry' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'notBefore' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'validPackages' } },
                ],
            },
        },
    ],
};
export const LaunchPermissionFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LaunchPermission' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LaunchPermission' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'canLaunch' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                ],
            },
        },
    ],
};
export const UploaderFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Uploader' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploaderConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'requestAccessKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'requestEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'signatureEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'keyPrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'signatureVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                ],
            },
        },
    ],
};
export const ValidationErrorFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationError' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'StructuredBriefValidationError' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                ],
            },
        },
    ],
};
export const CommonBriefFieldsFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CommonBriefFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StructuredBrief' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'schemaId' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'projectIds' },
                        name: { kind: 'Name', value: 'foreignKeys' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CategoryFields' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploader' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Uploader' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '16' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'DesignerCard_User' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designers' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'DesignerCard_User' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ValidationError' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designersWithSource' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductFixedPriceProject' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Uploader' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploaderConfig' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'requestAccessKey' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'requestEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'signatureEndpoint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'keyPrefix' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'signatureVersion' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CategoryFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Category' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'priceRange' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationError' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'StructuredBriefValidationError' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalDetails' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageImage' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headerVideo' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageHeaderVideo' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'fulfilmentMpvId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'Marketing' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categoryExperience' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Marketing' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Marketing' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageDetails' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageDetails' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ctaLink' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageImage' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageImage' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'alt' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageHeaderVideo' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageHeaderVideo' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'src' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerCard_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignerMeta_User' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageSources' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'original',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mediaCrop',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerMeta_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'penaltyState' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'utcOffset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastSeenAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locales' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'categories' },
                                    name: { kind: 'Name', value: 'categoriesWithValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const LaunchBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'launchBrief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'launchStructuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'projectIds' },
                                    name: { kind: 'Name', value: 'foreignKeys' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'partnerCoupon' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'state' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'job' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type LaunchBriefMutationFn = Apollo.MutationFunction<
    LaunchBriefMutation,
    LaunchBriefMutationVariables
>;
export type LaunchBriefComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        LaunchBriefMutation,
        LaunchBriefMutationVariables
    >,
    'mutation'
>;

export const LaunchBriefComponent = (props: LaunchBriefComponentProps) => (
    <ApolloReactComponents.Mutation<LaunchBriefMutation, LaunchBriefMutationVariables>
        mutation={LaunchBriefDocument}
        {...props}
    />
);

/**
 * __useLaunchBriefMutation__
 *
 * To run a mutation, you first call `useLaunchBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchBriefMutation, { data, loading, error }] = useLaunchBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchBriefMutation(
    baseOptions?: Apollo.MutationHookOptions<LaunchBriefMutation, LaunchBriefMutationVariables>
) {
    return Apollo.useMutation<LaunchBriefMutation, LaunchBriefMutationVariables>(
        LaunchBriefDocument,
        baseOptions
    );
}
export type LaunchBriefMutationHookResult = ReturnType<typeof useLaunchBriefMutation>;
export type LaunchBriefMutationResult = Apollo.MutationResult<LaunchBriefMutation>;
export type LaunchBriefMutationOptions = Apollo.BaseMutationOptions<
    LaunchBriefMutation,
    LaunchBriefMutationVariables
>;
export const ClaimBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'claimBrief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimStructuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contacts' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'limit' },
                                            value: { kind: 'IntValue', value: '16' },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'DesignerCard_User' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerCard_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignerMeta_User' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designs' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'imageSources' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'original',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'mediaCrop',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DesignerMeta_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'penaltyState' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'profile' },
                        name: { kind: 'Name', value: 'createProfile' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'responsivenessScore' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'utcOffset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastSeenAt' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reviewRating' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locales' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'biography' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'categories' },
                                    name: { kind: 'Name', value: 'categoriesWithValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedProjectsCount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'repeatCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isAvailable' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type ClaimBriefMutationFn = Apollo.MutationFunction<
    ClaimBriefMutation,
    ClaimBriefMutationVariables
>;
export type ClaimBriefComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<ClaimBriefMutation, ClaimBriefMutationVariables>,
    'mutation'
>;

export const ClaimBriefComponent = (props: ClaimBriefComponentProps) => (
    <ApolloReactComponents.Mutation<ClaimBriefMutation, ClaimBriefMutationVariables>
        mutation={ClaimBriefDocument}
        {...props}
    />
);

/**
 * __useClaimBriefMutation__
 *
 * To run a mutation, you first call `useClaimBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimBriefMutation, { data, loading, error }] = useClaimBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClaimBriefMutation(
    baseOptions?: Apollo.MutationHookOptions<ClaimBriefMutation, ClaimBriefMutationVariables>
) {
    return Apollo.useMutation<ClaimBriefMutation, ClaimBriefMutationVariables>(
        ClaimBriefDocument,
        baseOptions
    );
}
export type ClaimBriefMutationHookResult = ReturnType<typeof useClaimBriefMutation>;
export type ClaimBriefMutationResult = Apollo.MutationResult<ClaimBriefMutation>;
export type ClaimBriefMutationOptions = Apollo.BaseMutationOptions<
    ClaimBriefMutation,
    ClaimBriefMutationVariables
>;
export const UpdateBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateBrief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'fields' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'StructuredBriefFieldsInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'updateStructuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'fields' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'fields' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'errors' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ValidationError' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dynamicFields' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'Field' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'paymentSummary' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'PaymentSummary' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ValidationError' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'StructuredBriefValidationError' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'Field' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DynamicField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'InputField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'InputField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'MultiInputField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MultiInputField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'TextAreaField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'TextAreaField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'SelectChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'SelectChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'MultiSelectChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MultiSelectChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'GridChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'GridChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'MultiGridChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MultiGridChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'RadioChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'RadioChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'BudgetField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BudgetField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'MultiChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'MultiChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'DateField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'DateField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'FilesField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FilesField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'SquarespacePackageChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'SquarespacePackageChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'LogoContestTierChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'LogoContestTierChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContestUpgradesChoiceField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ContestUpgradesChoiceField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'PrintServiceOptionsField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PrintServiceOptionsField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ClientConfiguredField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ClientConfiguredField' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'WorkEntityField' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'WorkEntityField' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'InputField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InputField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'helperText' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'inputValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MultiInputField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MultiInputField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiInputValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'TextAreaField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TextAreaField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'textAreaValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SelectChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SelectChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'choiceValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'group' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MultiSelectChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MultiSelectChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiChoiceValues' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'GridChoiceField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GridChoiceField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'choiceValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'footnote' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MultiGridChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'MultiGridChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiGridChoiceValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'RadioChoiceField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RadioChoiceField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'choiceValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BudgetField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BudgetField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'budgetValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'zeroValueLabel' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'MultiChoiceField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MultiChoiceField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtextLink' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'multiChoiceValue' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'DateField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DateField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'dateValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FilesField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilesField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'allowedFileTypes' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filesValue' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'bucket' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'previewable' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtextLink' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tooltip' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SquarespacePackageChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SquarespacePackageChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'squarespacePackageChoiceValue' },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LogoContestTierChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'LogoContestTierChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'logoContestTierChoiceValue' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ContestUpgradesChoiceField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ContestUpgradesChoiceField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contestUpgradesChoiceValues' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contestUpgradesChoiceSubtext' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'promotionalText' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'optionDetails' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PrintServiceOptionsField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PrintServiceOptionsField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtext' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ClientConfiguredField' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ClientConfiguredField' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'WorkEntityField' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WorkEntityField' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'workEntityValue' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'groupId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'required' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'immutable' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PaymentSummary' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PaymentSummary' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'tax' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'bundleSavings' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'amount' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type UpdateBriefMutationFn = Apollo.MutationFunction<
    UpdateBriefMutation,
    UpdateBriefMutationVariables
>;
export type UpdateBriefComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        UpdateBriefMutation,
        UpdateBriefMutationVariables
    >,
    'mutation'
>;

export const UpdateBriefComponent = (props: UpdateBriefComponentProps) => (
    <ApolloReactComponents.Mutation<UpdateBriefMutation, UpdateBriefMutationVariables>
        mutation={UpdateBriefDocument}
        {...props}
    />
);

/**
 * __useUpdateBriefMutation__
 *
 * To run a mutation, you first call `useUpdateBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBriefMutation, { data, loading, error }] = useUpdateBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateBriefMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateBriefMutation, UpdateBriefMutationVariables>
) {
    return Apollo.useMutation<UpdateBriefMutation, UpdateBriefMutationVariables>(
        UpdateBriefDocument,
        baseOptions
    );
}
export type UpdateBriefMutationHookResult = ReturnType<typeof useUpdateBriefMutation>;
export type UpdateBriefMutationResult = Apollo.MutationResult<UpdateBriefMutation>;
export type UpdateBriefMutationOptions = Apollo.BaseMutationOptions<
    UpdateBriefMutation,
    UpdateBriefMutationVariables
>;
export const BriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'Brief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'structuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'foreignKeys' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isBundled' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'schemaId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'designers' },
                                    name: { kind: 'Name', value: 'designersWithSource' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'source' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type BriefComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<BriefQuery, BriefQueryVariables>,
    'query'
> &
    ({ variables: BriefQueryVariables; skip?: boolean } | { skip: boolean });

export const BriefComponent = (props: BriefComponentProps) => (
    <ApolloReactComponents.Query<BriefQuery, BriefQueryVariables>
        query={BriefDocument}
        {...props}
    />
);

/**
 * __useBriefQuery__
 *
 * To run a query within a React component, call `useBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefQuery(
    baseOptions: Apollo.QueryHookOptions<BriefQuery, BriefQueryVariables>
) {
    return Apollo.useQuery<BriefQuery, BriefQueryVariables>(BriefDocument, baseOptions);
}
export function useBriefLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BriefQuery, BriefQueryVariables>
) {
    return Apollo.useLazyQuery<BriefQuery, BriefQueryVariables>(BriefDocument, baseOptions);
}
export type BriefQueryHookResult = ReturnType<typeof useBriefQuery>;
export type BriefLazyQueryHookResult = ReturnType<typeof useBriefLazyQuery>;
export type BriefQueryResult = Apollo.QueryResult<BriefQuery, BriefQueryVariables>;
export const GetOrderPaymentRequestDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getOrderPaymentRequest' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'redirectPath' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'structuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'orderPaymentRequest' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'redirectPath' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'redirectPath' },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type GetOrderPaymentRequestComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetOrderPaymentRequestQuery,
        GetOrderPaymentRequestQueryVariables
    >,
    'query'
> &
    ({ variables: GetOrderPaymentRequestQueryVariables; skip?: boolean } | { skip: boolean });

export const GetOrderPaymentRequestComponent = (props: GetOrderPaymentRequestComponentProps) => (
    <ApolloReactComponents.Query<GetOrderPaymentRequestQuery, GetOrderPaymentRequestQueryVariables>
        query={GetOrderPaymentRequestDocument}
        {...props}
    />
);

/**
 * __useGetOrderPaymentRequestQuery__
 *
 * To run a query within a React component, call `useGetOrderPaymentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPaymentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPaymentRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      redirectPath: // value for 'redirectPath'
 *   },
 * });
 */
export function useGetOrderPaymentRequestQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOrderPaymentRequestQuery,
        GetOrderPaymentRequestQueryVariables
    >
) {
    return Apollo.useQuery<GetOrderPaymentRequestQuery, GetOrderPaymentRequestQueryVariables>(
        GetOrderPaymentRequestDocument,
        baseOptions
    );
}
export function useGetOrderPaymentRequestLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOrderPaymentRequestQuery,
        GetOrderPaymentRequestQueryVariables
    >
) {
    return Apollo.useLazyQuery<GetOrderPaymentRequestQuery, GetOrderPaymentRequestQueryVariables>(
        GetOrderPaymentRequestDocument,
        baseOptions
    );
}
export type GetOrderPaymentRequestQueryHookResult = ReturnType<
    typeof useGetOrderPaymentRequestQuery
>;
export type GetOrderPaymentRequestLazyQueryHookResult = ReturnType<
    typeof useGetOrderPaymentRequestLazyQuery
>;
export type GetOrderPaymentRequestQueryResult = Apollo.QueryResult<
    GetOrderPaymentRequestQuery,
    GetOrderPaymentRequestQueryVariables
>;
export const GetBriefLaunchPermissionsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getBriefLaunchPermissions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'structuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'launchPermissions' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'clientPermission' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'LaunchPermission',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'designerPermissions',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'LaunchPermission',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'LaunchPermission' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LaunchPermission' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'canLaunch' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                ],
            },
        },
    ],
};
export type GetBriefLaunchPermissionsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        GetBriefLaunchPermissionsQuery,
        GetBriefLaunchPermissionsQueryVariables
    >,
    'query'
> &
    ({ variables: GetBriefLaunchPermissionsQueryVariables; skip?: boolean } | { skip: boolean });

export const GetBriefLaunchPermissionsComponent = (
    props: GetBriefLaunchPermissionsComponentProps
) => (
    <ApolloReactComponents.Query<
        GetBriefLaunchPermissionsQuery,
        GetBriefLaunchPermissionsQueryVariables
    >
        query={GetBriefLaunchPermissionsDocument}
        {...props}
    />
);

/**
 * __useGetBriefLaunchPermissionsQuery__
 *
 * To run a query within a React component, call `useGetBriefLaunchPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefLaunchPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefLaunchPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefLaunchPermissionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBriefLaunchPermissionsQuery,
        GetBriefLaunchPermissionsQueryVariables
    >
) {
    return Apollo.useQuery<GetBriefLaunchPermissionsQuery, GetBriefLaunchPermissionsQueryVariables>(
        GetBriefLaunchPermissionsDocument,
        baseOptions
    );
}
export function useGetBriefLaunchPermissionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBriefLaunchPermissionsQuery,
        GetBriefLaunchPermissionsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        GetBriefLaunchPermissionsQuery,
        GetBriefLaunchPermissionsQueryVariables
    >(GetBriefLaunchPermissionsDocument, baseOptions);
}
export type GetBriefLaunchPermissionsQueryHookResult = ReturnType<
    typeof useGetBriefLaunchPermissionsQuery
>;
export type GetBriefLaunchPermissionsLazyQueryHookResult = ReturnType<
    typeof useGetBriefLaunchPermissionsLazyQuery
>;
export type GetBriefLaunchPermissionsQueryResult = Apollo.QueryResult<
    GetBriefLaunchPermissionsQuery,
    GetBriefLaunchPermissionsQueryVariables
>;
